import { Fragment, useState } from "react";

// ui
import {
  Box,
  TableRow,
  TableCell,
  IconButton,
  FormControl,
  Select,
  MenuItem,
  TextField,
  FormHelperText,
  Checkbox,
  Tooltip,
} from "@mui/material";
import { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/system";
import EditNoteIcon from "@mui/icons-material/EditNote";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

// InterFace
import { DataColumn, EditDataDifine } from "../../config/dataInterface";

// api
import { getContractEditBefore } from "../../api/contract";
import { getTossUpEditBefore } from "../../api/tossUp";
import {
  getPresignedGetPicture,
  getPresignedGetOutsideFile,
} from "../../api/presignedURL";
import {
  getOptionSelects,
  getOptionSelectsTossUp,
  getOptionSelectsOutside,
} from "../../api/optionSelect";
import { getPaymentConfirmExcel } from "../../api/paymentConfirmExcel";
import { getScreenColumnSelectEditBefore } from "../../api/screenColumnConfigSelect";

// jotai
import { useAtomValue, useSetAtom } from "jotai";
import { AppAtoms } from "../../lib/store";

import { CONST } from "../../config/const";

export const CustomTextField = styled(TextField)({
  "& .MuiInputBase-input": {
    fontSize: "12px",
    height: "12px", // ここでフォントサイズを指定
  },
});
CustomTextField.defaultProps = {
  autoComplete: "off",
};

export const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: "1px 1px rgba(115, 115, 115, 0.8)",
    fontSize: 11,
  },
}));

interface DataDetailRowContractNumberMonthsProps {
  editAuth: string[];
  dataColumn: DataColumn;
  dataDetail: {
    [key: string]:
      | number
      | string
      | { [key: string]: string | number }[]
      | { [key: string]: string | string[] };
  } | null;
  dataDetailHistory: {
    selected_date: string;
    contract_version: number;
  }[];
  lastContractVersion: number;
  year_i: number;
  yearMonth: string;
  detailType: "datail" | "closing";
  rowBg?: string;
}

export function DataDetailRowContractNumberMonths(
  props: DataDetailRowContractNumberMonthsProps,
) {
  const {
    editAuth,
    dataColumn,
    dataDetail,
    dataDetailHistory,
    lastContractVersion,
    year_i,
    yearMonth,
    detailType,
    rowBg,
  } = props;

  const loginUser = useAtomValue(AppAtoms.loginUser);
  const pathname = useAtomValue(AppAtoms.pathname);
  return dataDetail ? (
    <Fragment key={"detaiTableYearMonthFragment" + year_i}>
      <TableRow className="dt-sub">
        <TableCell key={"tableDataYearMonthKomoku" + year_i} align="left" sx={{ color: "var(--color-sumi)", fontSize: "12px", backgroundColor: rowBg ?? "var(--color-washi)", paddingLeft: "var(--sp-6)" }}>
          <Box className="table-body">{yearMonth}</Box>
        </TableCell>
        <TableCell key={"tableDataYearMonthShosai" + year_i} align="left" sx={{ color: "var(--color-sumi)", fontSize: "12px", backgroundColor: rowBg ?? "var(--color-washi)" }}>
          <Box className="table-body">
            {dataDetail[dataColumn.key + year_i] as string | number}
          </Box>
        </TableCell>
        {loginUser?.authority &&
        editAuth.findIndex((authority) => authority === loginUser.authority) >
          -1 &&
        detailType === "datail" &&
        ((pathname == "/toss_up" && dataDetail["disable_change"] === 1) ||
          pathname != "/toss_up") &&
        ((dataDetailHistory.length > 0 &&
          dataDetail.contract_version === lastContractVersion) ||
          dataDetailHistory.length === 0) ? (
          <TableCell
            key={"tableDataYearMonthEdit" + year_i}
            align="center"
          ></TableCell>
        ) : null}
      </TableRow>
    </Fragment>
  ) : null;
}

interface DataDetailRowCustomerInfoProps {
  editAuth: string[];
  dataColumn: DataColumn;
  dataDetail: {
    [key: string]:
      | number
      | string
      | { [key: string]: string | number }[]
      | { [key: string]: string | string[] };
  } | null;
  dataDetailHistory: {
    selected_date: string;
    contract_version: number;
  }[];
  lastContractVersion: number;
  setEditData: (data: EditDataDifine | null) => void;
  option_i: number;
  option_id: string | number;
  option_name: string | number;
  option_type: string | number;
  tel_flg: string | number;
  name_flg: string | number;
  company_name_flg: string | number;
  half_width_number_flg?: string | number;
  multi_text_flg: string | number;
  entry_method: string | number;
  optionValue: string | string[];
  customer_info: {
    [key: string]: string | string[];
  };
  detailType: "datail" | "closing";
  rowBg?: string;
}

export function DataDetailRowCustomerInfo(
  props: DataDetailRowCustomerInfoProps,
) {
  const {
    editAuth,
    dataColumn,
    dataDetail,
    dataDetailHistory,
    lastContractVersion,
    setEditData,
    option_i,
    option_id,
    option_name,
    option_type,
    tel_flg,
    name_flg,
    company_name_flg,
    half_width_number_flg,
    multi_text_flg,
    entry_method,
    optionValue,
    customer_info,
    detailType,
    rowBg,
  } = props;

  const loginUser = useAtomValue(AppAtoms.loginUser);
  const setIsLoading = useSetAtom(AppAtoms.isLoading);
  const pathname = useAtomValue(AppAtoms.pathname);
  async function downloadContractPicture(destination_key: string) {
    setIsLoading(true);
    const header_location = await getPresignedGetPicture(destination_key);
    if (header_location != "None") {
      const url = header_location;
      const link = document.createElement("a");
      link.href = header_location;
      document.body.appendChild(link);
      link.click();
      URL.revokeObjectURL(url);
      link.parentNode?.removeChild(link);
    }
    setIsLoading(false);
  }
  return dataDetail ? (
    <Fragment key={"detaiTableOptionFragment_" + option_i}>
      <TableRow sx={rowBg ? { backgroundColor: rowBg } : undefined}>
        <TableCell key={"detaiTableOptionKomoku_" + option_i} align="left" sx={{ color: "var(--color-sumi)", fontSize: "13px" }}>
          <Box className="table-body">{option_name}</Box>
        </TableCell>
        <TableCell
          key={"detaiTableOptionSyosai_" + option_i}
          align="left"
          sx={{ color: "var(--color-sumi)", fontSize: "13px" }}
          onClick={() => {
            if (option_type === 4 && optionValue && optionValue != "") {
              downloadContractPicture(optionValue as string);
            }
          }}
        >
          <Box className="table-body">
            {Array.isArray(optionValue)
              ? optionValue.join("、")
              : option_type === 4 && optionValue && optionValue != ""
                ? optionValue.split("/").pop()
                : optionValue}
            {option_type === 4 && optionValue && optionValue != "" ? (
              <IconButton aria-label="detail row" size="small">
                <FileDownloadIcon fontSize="medium" />
              </IconButton>
            ) : null}
          </Box>
        </TableCell>
        {loginUser?.authority &&
        editAuth.findIndex((authority) => authority === loginUser.authority) >
          -1 &&
        detailType === "datail" &&
        ((pathname == "/toss_up" && dataDetail["disable_change"] === 1) ||
          pathname != "/toss_up") &&
        ((dataDetailHistory.length > 0 &&
          dataDetail.contract_version === lastContractVersion) ||
          dataDetailHistory.length === 0) ? (
          <TableCell key={"tableDataYearMonthEdit"} align="center">
            <IconButton
              aria-label="detail row"
              size="small"
              onClick={async () => {
                if (
                  option_type === 0 ||
                  option_type === 3 ||
                  option_type === 4
                ) {
                  setEditData({
                    status: "before",
                    editType:
                      option_type === 0
                        ? multi_text_flg === 1
                          ? "customer_multitext"
                          : "customer_text"
                        : option_type === 3
                          ? "customer_date"
                          : "customer_picture",
                    tableId: dataDetail.id as string,
                    id: dataDetail[dataColumn.editId] as number,
                    key: option_name as string,
                    name: option_name as string,
                    value: customer_info,
                    editValue: customer_info,
                    editPhoneNumber: dataDetail.customer_phone_number as string,
                    editName: dataDetail.customer_name as string,
                    editCustomerName:
                      dataDetail.customer_company_name as string,
                    tel_flg: tel_flg as number,
                    name_flg: name_flg as number,
                    company_name_flg: company_name_flg as number,
                    half_width_number_flg: half_width_number_flg as number,
                    customerList: [],
                    payment_method_id: dataDetail.payment_method_id as string,
                    service_id: dataDetail.service_id as string,
                    customer_picture: null,
                  });
                } else {
                  setIsLoading(true);
                  setEditData({
                    status: "editing",
                    editType:
                      option_type === 0
                        ? multi_text_flg === 1
                          ? "customer_multitext"
                          : "customer_text"
                        : option_type === 1
                          ? "customer_select_one"
                          : option_type === 2
                            ? "customer_select_multiple"
                            : option_type === 3
                              ? "customer_date"
                              : "customer_picture",
                    tableId: dataDetail.id as string,
                    id: dataDetail[dataColumn.editId] as number,
                    key: option_name as string,
                    name: option_name as string,
                    value: customer_info,
                    editValue: customer_info,
                    editPhoneNumber: dataDetail.customer_phone_number as string,
                    editName: dataDetail.customer_name as string,
                    editCustomerName:
                      dataDetail.customer_company_name as string,
                    tel_flg: tel_flg as number,
                    name_flg: name_flg as number,
                    company_name_flg: company_name_flg as number,
                    half_width_number_flg: half_width_number_flg as number,
                    customerList: [],
                    payment_method_id: dataDetail.payment_method_id as string,
                    service_id: dataDetail.service_id as string,
                    customer_picture: null,
                  });
                  const optionSelects =
                    pathname == "/toss_up"
                      ? await getOptionSelectsTossUp(option_id as number)
                      : entry_method === 0
                        ? await getOptionSelects(option_id as number)
                        : entry_method === 1
                          ? await getOptionSelectsOutside(option_id as number)
                          : [];
                  setEditData({
                    status: "before",
                    editType:
                      option_type === 0
                        ? multi_text_flg === 1
                          ? "customer_multitext"
                          : "customer_text"
                        : option_type === 1
                          ? "customer_select_one"
                          : option_type === 2
                            ? "customer_select_multiple"
                            : option_type === 3
                              ? "customer_date"
                              : "customer_picture",
                    tableId: dataDetail.id as string,
                    id: dataDetail[dataColumn.editId] as number,
                    key: option_name as string,
                    name: option_name as string,
                    value: customer_info,
                    editValue: customer_info,
                    editPhoneNumber: dataDetail.customer_phone_number as string,
                    editName: dataDetail.customer_name as string,
                    editCustomerName:
                      dataDetail.customer_company_name as string,
                    tel_flg: tel_flg as number,
                    name_flg: name_flg as number,
                    company_name_flg: company_name_flg as number,
                    customerList: optionSelects,
                    payment_method_id: dataDetail.payment_method_id as string,
                    service_id: dataDetail.service_id as string,
                    customer_picture: null,
                  });
                  setIsLoading(false);
                }
              }}
            >
              <EditNoteIcon fontSize="medium" sx={{ color: "var(--color-kohaku-text)" }} />
            </IconButton>
          </TableCell>
        ) : null}
      </TableRow>
    </Fragment>
  ) : null;
}

interface DataDetailRowContractInfoProps {
  editAuth: string[];
  dataDetail: {
    [key: string]:
      | number
      | string
      | { [key: string]: string | number }[]
      | { [key: string]: string | string[] };
  } | null;
  dataDetailHistory: {
    selected_date: string;
    contract_version: number;
  }[];
  lastContractVersion: number;
  key_i: number;
  contractInfoKey: string;
  contractInfoValue: string;
  detailType: "datail" | "closing";
  rowBg?: string;
}

export function DataDetailRowContractInfo(
  props: DataDetailRowContractInfoProps,
) {
  const {
    editAuth,
    dataDetail,
    dataDetailHistory,
    lastContractVersion,
    key_i,
    contractInfoKey,
    contractInfoValue,
    detailType,
    rowBg,
  } = props;

  const loginUser = useAtomValue(AppAtoms.loginUser);
  const pathname = useAtomValue(AppAtoms.pathname);
  return dataDetail ? (
    <Fragment key={"detailTableContractInfoFragment_" + key_i}>
      <TableRow className="dt-sub">
        <TableCell
          key={"detailTableContractInfoKomoku_" + key_i}
          align="left"
          sx={{ color: "var(--color-sumi)", fontSize: "12px", backgroundColor: rowBg ?? "var(--color-washi)", paddingLeft: "var(--sp-6)" }}
        >
          <Box className="table-body">{contractInfoKey}</Box>
        </TableCell>
        <TableCell
          key={"detailTableContractInfoSyosai_" + key_i}
          align="left"
          sx={{ color: "var(--color-sumi)", fontSize: "12px", backgroundColor: rowBg ?? "var(--color-washi)" }}
        >
          <Box className="table-body">
            {contractInfoValue === "" ? "-" : contractInfoValue}
          </Box>
        </TableCell>
        {loginUser?.authority &&
        editAuth.findIndex((authority) => authority === loginUser.authority) >
          -1 &&
        detailType === "datail" &&
        ((pathname == "/toss_up" && dataDetail["disable_change"] === 1) ||
          pathname != "/toss_up") &&
        ((dataDetailHistory.length > 0 &&
          dataDetail.contract_version === lastContractVersion) ||
          dataDetailHistory.length === 0) ? (
          <TableCell
            key={"detailTableContractInfoEdit_" + key_i}
            align="center"
          ></TableCell>
        ) : null}
      </TableRow>
    </Fragment>
  ) : null;
}

export function DataDetailRowOptionSelect(props: {
  optionSelect: {
    [key: string]: string;
  };
  key_i: number;
  rowBg?: string;
}) {
  const { optionSelect, key_i, rowBg } = props;
  return (
    <Fragment key={"detaiTableFragmentOptionSelect" + key_i}>
      <TableRow sx={rowBg ? { backgroundColor: rowBg } : undefined}>
        <TableCell key={"tableDataKomokuOptionSelect" + key_i} align="left">
          <Box className="table-body">選択肢 - {key_i + 1}</Box>
        </TableCell>
        <TableCell key={"tableDataShosaiOptionSelect" + key_i} align="left">
          <Box className="table-body">{optionSelect["option_select"]}</Box>
        </TableCell>
      </TableRow>
    </Fragment>
  );
}

interface DataDetailRowElseProps {
  editAuth: string[];
  dataDetail: {
    [key: string]:
      | number
      | string
      | { [key: string]: string | number }[]
      | { [key: string]: string | string[] };
  } | null;
  dataDetailHistory: {
    selected_date: string;
    contract_version: number;
  }[];
  lastContractVersion: number;
  setEditData: (data: EditDataDifine | null) => void;
  i: number;
  dataColumnName: string;
  dataColumnKey: string;
  dataColumnEdit: boolean;
  dataColumnEditType:
    | "list"
    | "multitext"
    | "text"
    | "outside_site_logo"
    | "outside_site_favicon"
    | "site_pdf_path"
    | "screen_column"
    | "entry_info"
    | "toss_up_info";
  dataColumnTableValue:
    | "text"
    | "number"
    | "check"
    | "edit_check"
    | "downloadPaymentExcel"
    | "outside_site_logo"
    | "outside_site_favicon"
    | "site_pdf_path"
    | "status_chip"
    | "text_chip"
    | null;
  dataColumnEditId: string;
  detailTitle: string;
  getGroupList: (id: string) => void;
  detailType: "datail" | "closing";
  setSelectServiseInfo: (value: {
    service_plan_data: { service_name: string }[];
    service_content_data: { service_name: string }[];
    service_campaign_pulldown_data: { service_name: string }[];
    service_campaign_checkbox_data: { service_name: string }[];
  }) => void;
  setSelectTossUpInfo: (value: {
    tossUpCategoryNameList: {
      category_id: number;
      category_name: string;
    }[];
    tossUpProductNameList: {
      category_id: number;
      category_name: string;
      product_name: string;
    }[];
  }) => void;
  rowBg?: string;
}

export function DataDetailRowElse(props: DataDetailRowElseProps) {
  const {
    editAuth,
    dataDetail,
    dataDetailHistory,
    lastContractVersion,
    setEditData,
    i,
    dataColumnName,
    dataColumnKey,
    dataColumnEdit,
    dataColumnEditType,
    dataColumnEditId,
    dataColumnTableValue,
    detailTitle,
    getGroupList,
    detailType,
    setSelectServiseInfo,
    setSelectTossUpInfo,
    rowBg,
  } = props;
  const loginUser = useAtomValue(AppAtoms.loginUser);
  const pathname = useAtomValue(AppAtoms.pathname);
  const [openTooltip, setOpenTooltip] = useState(false);
  const setIsLoading = useSetAtom(AppAtoms.isLoading);
  async function downloadPaymentExcel(
    payment_year: string,
    payment_month: string,
    payment_sale_company_id: number,
  ) {
    setIsLoading(true);
    const responce = await getPaymentConfirmExcel({
      payment_year,
      payment_month,
      payment_sale_company_id,
    });
    if (responce != "None") {
      const url = responce;
      const link = document.createElement("a");
      link.href = responce;
      document.body.appendChild(link);
      link.click();
      URL.revokeObjectURL(url);
      link.parentNode?.removeChild(link);
    }
    setIsLoading(false);
  }
  async function downloadContractPicture(destination_key: string) {
    setIsLoading(true);
    const header_location = await getPresignedGetOutsideFile(destination_key);
    if (header_location != "None") {
      const url = header_location;
      const link = document.createElement("a");
      link.href = header_location;
      document.body.appendChild(link);
      link.click();
      URL.revokeObjectURL(url);
      link.parentNode?.removeChild(link);
    }
    setIsLoading(false);
  }
  return dataDetail ? (
    <Fragment key={"detaiTableFragment" + i}>
      <TableRow sx={rowBg ? { backgroundColor: rowBg } : undefined}>
        <TableCell key={"tableDataKomoku" + i} align="left" sx={{ color: "var(--color-sumi)", fontSize: "13px" }}>
          <Box className="table-body">{dataColumnName}</Box>
        </TableCell>

        <LightTooltip
          onClose={() => setOpenTooltip(false)}
          open={openTooltip}
          title="コピーしました"
        >
          {dataColumnTableValue == "downloadPaymentExcel" ? (
            <TableCell
              key={"tableDataShosai" + i}
              align="left"
              sx={{ color: "var(--color-sumi)", fontSize: "13px" }}
              onClick={() => {
                downloadPaymentExcel(
                  dataDetail["payment_year"] as string,
                  dataDetail["payment_month"] as string,
                  dataDetail["payment_sale_company_id"] as number,
                );
              }}
            >
              <Box className="table-body">
                <IconButton
                  disabled={
                    (dataDetail["payment_year"] as string) == "-" ||
                    (dataDetail["payment_month"] as string) == "-"
                  }
                  aria-label="detail row"
                  size="small"
                >
                  <FileDownloadIcon fontSize="medium" />
                </IconButton>
              </Box>
            </TableCell>
          ) : dataColumnTableValue == "outside_site_logo" ||
            dataColumnTableValue == "outside_site_favicon" ||
            dataColumnTableValue == "site_pdf_path" ? (
            <TableCell
              key={"tableDataShosai" + i}
              align="left"
              sx={{ color: "var(--color-sumi)", fontSize: "13px" }}
              onClick={() => {
                downloadContractPicture(dataDetail[dataColumnKey] as string);
              }}
            >
              <Box className="table-body">
                {(dataDetail[dataColumnKey] as string).split("/").pop()}
                <IconButton aria-label="detail row" size="small">
                  <FileDownloadIcon fontSize="medium" />
                </IconButton>
              </Box>
            </TableCell>
          ) : (
            <TableCell
              key={"tableDataShosai" + i}
              align="left"
              sx={{ color: "var(--color-sumi)", fontSize: "13px" }}
              onClick={() => {
                if (dataColumnKey === "password") {
                  navigator.clipboard.writeText(
                    dataDetail["copy_password"] as string,
                  );
                  setOpenTooltip(true);
                } else if (
                  dataColumnKey === "outside_entry_url" ||
                  dataColumnKey === "outside_cancell_url"
                ) {
                  navigator.clipboard.writeText(
                    dataDetail[dataColumnKey] as string,
                  );
                  setOpenTooltip(true);
                }
              }}
            >
              <Box className="table-body">
                {dataDetail[dataColumnKey] as string | number}
                {dataColumnKey === "password" ||
                ((dataColumnKey === "outside_entry_url" ||
                  dataColumnKey === "outside_cancell_url") &&
                  dataDetail[dataColumnKey] !== "-") ? (
                  <IconButton aria-label="detail row" size="small">
                    <ContentCopyIcon fontSize="medium" />
                  </IconButton>
                ) : null}
              </Box>
            </TableCell>
          )}
        </LightTooltip>

        {loginUser?.authority &&
        editAuth.findIndex((authority) => authority === loginUser.authority) >
          -1 &&
        detailType === "datail" &&
        ((pathname == "/toss_up" && dataDetail["disable_change"] === 1) ||
          pathname != "/toss_up") &&
        ((dataDetailHistory.length > 0 &&
          dataDetail.contract_version === lastContractVersion) ||
          dataDetailHistory.length === 0) ? (
          <TableCell key={"tableDataEdit" + i} align="center">
            {dataColumnEdit &&
            ((dataColumnKey == "contract_number" &&
              dataDetail["edit_contract_number"] === 1 &&
              (loginUser?.authority === "マスターアカウント" ||
                loginUser?.authority === "スタッフアカウント")) ||
              dataColumnKey != "contract_number") &&
            (((dataColumnKey == "sns_id" ||
              dataColumnKey == "sns_toss_up_account_info" ||
              dataColumnKey == "sns_haeder" ||
              dataColumnKey == "sns_footer") &&
              dataDetail["sns_type"] !== "社内ChatWorkにエントリー情報通知" &&
              dataDetail["sns_type"] !== "社内ChatWorkにトスアップ情報通知") ||
              ((dataColumnKey == "cancell_sns_id" ||
                dataColumnKey == "cancell_sns_haeder" ||
                dataColumnKey == "cancell_sns_footer") &&
                dataDetail["cancell_sns_type"] !==
                  "社内ChatWorkにエントリー情報通知" &&
                dataDetail["cancell_sns_type"] !==
                  "社内ChatWorkにトスアップ情報通知") ||
              (dataColumnKey != "sns_id" &&
                dataColumnKey != "sns_toss_up_account_info" &&
                dataColumnKey != "sns_haeder" &&
                dataColumnKey != "sns_footer" &&
                dataColumnKey != "cancell_sns_id" &&
                dataColumnKey != "cancell_sns_haeder" &&
                dataColumnKey != "cancell_sns_footer")) &&
            ((dataColumnKey == "product_contract_number" &&
              dataDetail["product_key"] === "申込番号") ||
              dataColumnKey != "product_contract_number") &&
            ((dataColumnKey == "login_status" &&
              dataDetail["login_status"] === "正常") ||
              dataColumnKey != "login_status") &&
            ((dataColumnKey == "sale_company_group_id" &&
              (dataDetail["authority"] === "営業MGR" ||
                dataDetail["authority"] === "営業アカウント" ||
                dataDetail["authority"] === "トスアップアカウント")) ||
              dataColumnKey != "sale_company_group_id") &&
            ((dataColumnKey == "authority" &&
              (dataDetail["authority"] === "営業MGR" ||
                dataDetail["authority"] === "営業アカウント" ||
                dataDetail["authority"] === "トスアップアカウント")) ||
              dataColumnKey != "authority") &&
            ((dataColumnKey == "incentive_status" &&
              dataDetail["incentive_status_conf"] === "ステータスを指定する") ||
              dataColumnKey != "incentive_status") &&
            ((dataColumnKey == "follow_call_entry_status" &&
              dataDetail["follow_call_entry_status_conf"] ===
                "ステータスを指定する") ||
              dataColumnKey != "follow_call_entry_status") &&
            ((dataColumnKey == "sale_company_group_name" &&
              (dataDetail["authority"] === "営業MGR" ||
                dataDetail["authority"] === "営業アカウント" ||
                dataDetail["authority"] === "トスアップアカウント")) ||
              dataColumnKey != "sale_company_group_name") &&
            ((dataColumnKey == "service_required_optional_pull_down" &&
              dataDetail["service_option_name_pull_down"] !== "-") ||
              dataColumnKey != "service_required_optional_pull_down") &&
            ((dataColumnKey == "service_required_optional_check_box" &&
              dataDetail["service_option_name_check_box"] !== "-") ||
              dataColumnKey != "service_required_optional_check_box") &&
            ((dataColumnKey == "outside_cancell_form_text" &&
              dataDetail["outside_cancell_form"] ===
                "解約フォームを作成する") ||
              dataColumnKey != "outside_cancell_form_text") &&
            ((dataColumnKey == "outside_cancell_form_mail_address" &&
              dataDetail["outside_cancell_form"] ===
                "解約フォームを作成する") ||
              dataColumnKey != "outside_cancell_form_mail_address") &&
            ((dataColumnKey == "toss_up_status" &&
              (loginUser?.authority == "マスターアカウント" ||
                loginUser?.authority == "スタッフアカウント" ||
                loginUser?.authority == "パートナー" ||
                loginUser?.db_authority == "営業MGR")) ||
              dataColumnKey != "toss_up_status") &&
            ((dataColumnKey == "service_plan_name" &&
              (loginUser?.authority == "マスターアカウント" ||
                loginUser?.authority == "スタッフアカウント")) ||
              dataColumnKey != "service_plan_name") &&
            ((dataColumnKey == "service_content_names" &&
              (loginUser?.authority == "マスターアカウント" ||
                loginUser?.authority == "スタッフアカウント")) ||
              dataColumnKey != "service_content_names") &&
            ((dataColumnKey == "service_campaig_names" &&
              (loginUser?.authority == "マスターアカウント" ||
                loginUser?.authority == "スタッフアカウント")) ||
              dataColumnKey != "service_campaig_names") &&
            ((dataColumnKey == "category_name_list" &&
              (loginUser?.authority == "マスターアカウント" ||
                loginUser?.authority == "スタッフアカウント")) ||
              dataColumnKey != "category_name_list") &&
            ((dataColumnKey == "product_name_list" &&
              (loginUser?.authority == "マスターアカウント" ||
                loginUser?.authority == "スタッフアカウント")) ||
              dataColumnKey != "product_name_list") &&
            ((dataColumnKey == "contract_state" &&
              (loginUser?.authority == "マスターアカウント" ||
                loginUser?.authority == "スタッフアカウント")) ||
              dataColumnKey != "contract_state") ? (
              <IconButton
                aria-label="detail row"
                size="small"
                onClick={async () => {
                  const key =
                    dataColumnKey === "follow_call_day_offset" &&
                    dataDetail.follow_call_base_day_conf === "開通日"
                      ? "follow_call_day_offset_open"
                      : dataColumnKey;
                  if (dataColumnEditType === "screen_column") {
                    // 独自項目の場合
                    // 事前に選択肢を取得しておく
                    setIsLoading(true);
                    setEditData({
                      status: "editing",
                      editType: "column_text",
                      tableId: dataDetail.id as string,
                      id: dataDetail[dataColumnEditId] as number,
                      key: key as string,
                      name: dataColumnName as string,
                      value: dataDetail[dataColumnKey] as string,
                      editValue: dataDetail[dataColumnKey] as string,
                      editPhoneNumber: "",
                      editName: "",
                      editCustomerName: "",
                      tel_flg: 0,
                      name_flg: 0,
                      company_name_flg: 0,
                      half_width_number_flg: 0,
                      customerList: [],
                      payment_method_id: dataDetail.payment_method_id as string,
                      service_id: dataDetail.service_id as string,
                      customer_picture: null,
                    });
                    const { customerList, editType } =
                      await getScreenColumnSelectEditBefore(
                        dataDetail.screen_name as string,
                        dataDetail.id as string,
                        dataColumnKey as string,
                      );
                    setEditData({
                      status: "before",
                      editType:
                        editType === "column_select_one" ||
                        editType === "column_select_multiple" ||
                        editType === "column_date"
                          ? editType
                          : "column_text",
                      tableId: dataDetail.id as string,
                      id: dataDetail[dataColumnEditId] as number,
                      key: key as string,
                      name: dataColumnName as string,
                      value: dataDetail[dataColumnKey] as string,
                      editValue:
                        editType === "column_select_multiple"
                          ? ([] as string[])
                          : (dataDetail[dataColumnKey] as string),
                      editPhoneNumber: "",
                      editName: "",
                      editCustomerName: "",
                      tel_flg: 0,
                      name_flg: 0,
                      company_name_flg: 0,
                      customerList: customerList,
                      payment_method_id: dataDetail.payment_method_id as string,
                      service_id: dataDetail.service_id as string,
                      customer_picture: null,
                    });
                  } else if (dataColumnEditType == "entry_info") {
                    // 商材の情報から変更する「プラン・コンテンツ・キャンペーンの一覧」を取得
                    setIsLoading(true);
                    setEditData({
                      status: "editing",
                      editType: dataColumnEditType,
                      tableId: dataDetail.id as string,
                      id: dataDetail[dataColumnEditId] as number,
                      key: "entry_info",
                      name: "エントリー情報",
                      value: "",
                      editValue: {
                        productId: dataDetail.product_id as string,
                        productName: "",
                        servicePlanName: "",
                        serviceContentNameList: [],
                        serviceCampaignPulldownName: "",
                        serviceCampaignCheckboxName: [],
                      },
                      editPhoneNumber: "",
                      editName: "",
                      editCustomerName: "",
                      tel_flg: 0,
                      name_flg: 0,
                      company_name_flg: 0,
                      half_width_number_flg: 0,
                      customerList: [],
                      payment_method_id: dataDetail.payment_method_id as string,
                      service_id: dataDetail.service_id as string,
                      customer_picture: null,
                    });
                    const {
                      product_name,
                      service_plan_data,
                      service_content_data,
                      service_campaign_pulldown_data,
                      service_campaign_checkbox_data,
                      servicePlanName,
                      serviceContentNameList,
                      serviceCampaignPulldownName,
                      serviceCampaignCheckboxName,
                    } = await getContractEditBefore(
                      dataDetail.id as string,
                      dataDetail.product_id as string,
                    );
                    const _service_campaign_pulldown_data =
                      service_campaign_pulldown_data.length > 0
                        ? [
                            { service_name: "" },
                            ...service_campaign_pulldown_data,
                          ]
                        : service_campaign_pulldown_data;
                    setSelectServiseInfo({
                      service_plan_data,
                      service_content_data,
                      service_campaign_pulldown_data:
                        _service_campaign_pulldown_data,
                      service_campaign_checkbox_data,
                    });
                    setEditData({
                      status: "before",
                      editType: dataColumnEditType,
                      tableId: dataDetail.id as string,
                      id: dataDetail[dataColumnEditId] as number,
                      key: "entry_info",
                      name: "エントリー情報",
                      value: "",
                      editValue: {
                        productId: dataDetail.product_id as string,
                        productName: product_name,
                        servicePlanName,
                        serviceContentNameList,
                        serviceCampaignPulldownName,
                        serviceCampaignCheckboxName,
                      },
                      editPhoneNumber: "",
                      editName: "",
                      editCustomerName: "",
                      tel_flg: 0,
                      name_flg: 0,
                      company_name_flg: 0,
                      half_width_number_flg: 0,
                      customerList: [],
                      payment_method_id: dataDetail.payment_method_id as string,
                      service_id: dataDetail.service_id as string,
                      customer_picture: null,
                    });
                  } else if (dataColumnEditType == "toss_up_info") {
                    // 商材の情報から変更する「商材・カテゴリーの一覧」を取得
                    setIsLoading(true);
                    setEditData({
                      status: "editing",
                      editType: dataColumnEditType,
                      tableId: dataDetail.id as string,
                      id: dataDetail[dataColumnEditId] as number,
                      key: "toss_up_info",
                      name: "トスアップ情報",
                      value: "",
                      editValue: {
                        category_id_list: [],
                        product_name_list: [],
                      },
                      editPhoneNumber: "",
                      editName: "",
                      editCustomerName: "",
                      tel_flg: 0,
                      name_flg: 0,
                      company_name_flg: 0,
                      half_width_number_flg: 0,
                      customerList: [],
                      payment_method_id: dataDetail.payment_method_id as string,
                      service_id: dataDetail.service_id as string,
                      customer_picture: null,
                    });
                    const {
                      tossUpCategoryNameList,
                      tossUpProductNameList,
                      category_id_list,
                      product_name_list,
                    } = await getTossUpEditBefore(dataDetail.id as string);
                    setSelectTossUpInfo({
                      tossUpCategoryNameList,
                      tossUpProductNameList,
                    });
                    setEditData({
                      status: "before",
                      editType: dataColumnEditType,
                      tableId: dataDetail.id as string,
                      id: dataDetail[dataColumnEditId] as number,
                      key: "toss_up_info",
                      name: "トスアップ情報",
                      value: "",
                      editValue: {
                        category_id_list,
                        product_name_list,
                      },
                      editPhoneNumber: "",
                      editName: "",
                      editCustomerName: "",
                      tel_flg: 0,
                      name_flg: 0,
                      company_name_flg: 0,
                      half_width_number_flg: 0,
                      customerList: [],
                      payment_method_id: dataDetail.payment_method_id as string,
                      service_id: dataDetail.service_id as string,
                      customer_picture: null,
                    });
                  } else {
                    if (
                      dataColumnKey == "sale_company_group_id" &&
                      detailTitle === "アカウント詳細"
                    ) {
                      setEditData({
                        status: "editing",
                        editType: dataColumnEditType,
                        tableId: dataDetail.id as string,
                        id: dataDetail[dataColumnEditId] as number,
                        key: key as string,
                        name: dataColumnName as string,
                        value: dataDetail[dataColumnKey] as string,
                        editValue: dataDetail[dataColumnKey] as string,
                        editPhoneNumber: "",
                        editName: "",
                        editCustomerName: "",
                        tel_flg: 0,
                        name_flg: 0,
                        company_name_flg: 0,
                        customerList: [],
                        payment_method_id:
                          dataDetail.payment_method_id as string,
                        service_id: dataDetail.service_id as string,
                        customer_picture: null,
                      });
                      await getGroupList(dataDetail.id as string);
                    }
                    setEditData({
                      status: "before",
                      editType: dataColumnEditType,
                      tableId: dataDetail.id as string,
                      id: dataDetail[dataColumnEditId] as number,
                      key: key as string,
                      name: dataColumnName as string,
                      value: dataDetail[dataColumnKey] as string,
                      editValue: dataDetail[dataColumnKey] as string,
                      editPhoneNumber: "",
                      editName: "",
                      editCustomerName: "",
                      tel_flg: 0,
                      name_flg: 0,
                      company_name_flg: 0,
                      half_width_number_flg: 0,
                      customerList: [],
                      payment_method_id: dataDetail.payment_method_id as string,
                      service_id: dataDetail.service_id as string,
                      customer_picture: null,
                    });
                  }
                  setIsLoading(false);
                }}
              >
                <EditNoteIcon fontSize="medium" sx={{ color: "var(--color-kohaku-text)" }} />
              </IconButton>
            ) : null}
          </TableCell>
        ) : null}
      </TableRow>
    </Fragment>
  ) : null;
}

interface DataDetailRowOptionProps {
  option_i: number;
  uniqueOption: {
    [key: string]: string | number | string[];
  };
  option_selects: any[];
}

export function DataDetailRowOption(props: DataDetailRowOptionProps) {
  const { option_i, uniqueOption, option_selects } = props;
  return (
    <Box key={"optionBox_" + option_i}>
      <Box sx={{ fontWeight: 500, fontSize: "12px", color: "var(--color-sumi-light)", ml: "2px" }}>{uniqueOption.option_name}</Box>
      {uniqueOption.option_type === 0 ? (
        <>
          <CustomTextField
            disabled
            id="textFieldId"
            size="small"
            value={"フリー記入"}
            sx={{
              width: "calc(100% - 10px)",
              margin: "10px 5px",
            }}
          />
          <FormHelperText
            id="serch-name"
            sx={{
              width: "calc(100% - 10px)",
              textAlign: "right",
              marginTop: "-8px",
              marginRight: "5px",
              height: "25px",
            }}
          >
            {uniqueOption.required_optional === 1 ? "※必須" : "※任意"}
          </FormHelperText>
          {uniqueOption.option_comment !== "" ? (
            <FormHelperText
              id="serch-name"
              sx={{
                width: "calc(100% - 10px)",
                textAlign: "right",
                marginTop: "-8px",
                height: "25px",
              }}
            >
              {uniqueOption.option_comment}
            </FormHelperText>
          ) : null}
        </>
      ) : uniqueOption.option_type === 1 ? (
        <FormControl
          fullWidth
          sx={{
            marginTop: "10px",
            marginLeft: "5px",
            width: "calc(100% - 10px)",
          }}
        >
          <Select
            labelId="serch-input-label"
            id="serch-input-option"
            key={"tableColumnKomokuDataSelect" + option_i}
            sx={{
              height: "30px",
              textAlign: "end",
              fontSize: "14px",
            }}
          >
            {option_selects.map((option_select: string, select_i) => {
              return (
                <MenuItem
                  key={"tableColumnKomokuMenuItem" + option_i + "_" + select_i}
                  value={option_select}
                  sx={{
                    fontSize: "14px",
                    height: option_select === "" ? "14px" : "24px",
                    minHeight: "auto",
                  }}
                >
                  {option_select}
                </MenuItem>
              );
            })}
          </Select>
          <FormHelperText
            id="serch-name"
            sx={{
              width: "calc(100% - 20px)",
              textAlign: "right",
              marginRight: "5px",
              height: "25px",
            }}
          >
            {uniqueOption.required_optional === 1 ? "※必須" : "※任意"}
          </FormHelperText>
          {uniqueOption.option_comment !== "" ? (
            <FormHelperText
              id="serch-name"
              sx={{
                width: "calc(100% - 20px)",
                textAlign: "right",
                marginTop: "-8px",
                height: "25px",
              }}
            >
              {uniqueOption.option_comment}
            </FormHelperText>
          ) : null}
        </FormControl>
      ) : uniqueOption.option_type === 2 ? (
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            marginTop: "10px",
            marginBottom: "20px",
            marginLeft: "5px",
            width: "calc(100% - 10px)",
          }}
        >
          {option_selects.map((option_select: string, select_i) => {
            return (
              <Box
                key={"tableColumnKomokuDataBox" + option_i + "_" + select_i}
                sx={{ marginRight: "25px" }}
              >
                <Checkbox
                  sx={{
                    "& .MuiSvgIcon-root": { fontSize: 16 },
                    marginTop: "-5px",
                  }}
                />
                {option_select}
              </Box>
            );
          })}
          <FormHelperText
            id="serch-name"
            sx={{
              width: "calc(100% - 6px)",
              textAlign: "right",
              marginTop: "-2px",
              marginRight: "5px",
              height: "25px",
            }}
          >
            {uniqueOption.required_optional === 1 ? "※必須" : "※任意"}
          </FormHelperText>
          {uniqueOption.option_comment !== "" ? (
            <FormHelperText
              id="serch-name"
              sx={{
                width: "calc(100% - 6px)",
                textAlign: "right",
                marginTop: "-8px",
                height: "25px",
              }}
            >
              {uniqueOption.option_comment}
            </FormHelperText>
          ) : null}
        </Box>
      ) : uniqueOption.option_type === 3 ? (
        <>
          <CustomTextField
            disabled
            id="textFieldId"
            size="small"
            type="date"
            value={"2000-01-01"}
            sx={{
              width: "calc(100% - 10px)",
              margin: "10px 5px",
            }}
          />
          <FormHelperText
            id="serch-name"
            sx={{
              width: "calc(100% - 10px)",
              textAlign: "right",
              marginTop: "-8px",
              marginRight: "5px",
              height: "25px",
            }}
          >
            {uniqueOption.required_optional === 1 ? "※必須" : "※任意"}
          </FormHelperText>
          {uniqueOption.option_comment !== "" ? (
            <FormHelperText
              id="serch-name"
              sx={{
                width: "calc(100% - 10px)",
                textAlign: "right",
                marginTop: "-8px",
                height: "25px",
              }}
            >
              {uniqueOption.option_comment}
            </FormHelperText>
          ) : null}
        </>
      ) : uniqueOption.option_type === 4 ? (
        <>
          <input disabled id="textFieldPicture" type="file" />
          <FormHelperText
            id="serch-name"
            sx={{
              width: "calc(100% - 10px)",
              textAlign: "right",
              marginTop: "-8px",
              marginRight: "5px",
              height: "25px",
            }}
          >
            {uniqueOption.required_optional === 1 ? "※必須" : "※任意"}
          </FormHelperText>
          {uniqueOption.option_comment !== "" ? (
            <FormHelperText
              id="serch-name"
              sx={{
                width: "calc(100% - 10px)",
                textAlign: "right",
                marginTop: "-8px",
                height: "25px",
              }}
            >
              {uniqueOption.option_comment}
            </FormHelperText>
          ) : null}
        </>
      ) : null}
    </Box>
  );
}
